import { useContext, useEffect, useState } from "react"
import { AppContext } from "../context/createContext"

export default function useJackpotSoundshelper() {
  const [soundStates, setSoundStates] = useState("")
  const [backgroundState, setBackgroundState] = useState("")
  const { jackpotState } = useContext(AppContext)
  useEffect(() => {
    let timeout: any
    let timeout2: any
    let timeout3: any
    let timeout4: any

    if (jackpotState.state === "initJackpot") {
      timeout = setTimeout(() => {
        setSoundStates("lightSpeed")
        timeout4 = setTimeout(() => {
          setBackgroundState("lightSpeed")
        }, 1000)
      }, 1000)
    }
    if (jackpotState.state === "initBlackHole") {
      timeout2 = setTimeout(() => {
        setSoundStates("hyperdrive")
        timeout3 = setTimeout(() => {
          setSoundStates("portal")
          setBackgroundState("")
        }, 2000)
      }, 3000)
    }
    if (
      jackpotState.state === "initRound" ||
      jackpotState.state === "roundStarted"
    ) {
      setSoundStates("")
      setBackgroundState("")
    }

    return () => {
      clearTimeout(timeout)
      clearTimeout(timeout2)
      clearTimeout(timeout3)
      clearTimeout(timeout4)
    }
  }, [jackpotState.state])

  return { soundStates, backgroundState }
}
